/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.actionBar.cropImage": "Editer",
  "i18n.actionBar.removeImage": "Supprimer",
  "i18n.actionBar.swapImage": "Echanger",
  "i18n.additionalInfoItemLayers.smartSorted.new": "NOUVEAU!",
  "i18n.additionalProducts.addToCart": "Ajouter à la commande",
  "i18n.additionalProducts.frame.description": "Cadre en aluminium de qualité supérieure : finition argent mat, verre véritable haut de gamme, aucun collage nécessaire",
  "i18n.additionalProducts.frame.emotionalHook": "♥️ Bon à savoir :",
  "i18n.additionalProducts.frame.subtitle": "Une fois terminé, le puzzle devient un magnifique souvenir – grâce à notre <b>cadre</b> il est parfaitement mis en valeur.",
  "i18n.additionalProducts.frame2023.description": "Cadre en fibres de bois de qualité supérieure – facile à monter, sans vitre, contenant de la colle pour puzzle",
  "i18n.additionalProducts.framePlastic.description": "Cadre en aluminium de qualité supérieure : finition argent mat, verre synthétique anti-reflet, aucun collage nécessaire",
  "i18n.additionalProducts.glue.description": "Permet de coller jusqu’à deux puzzles de 1000 pièces, éponge d’application incluse",
  "i18n.additionalProducts.glue.hook": "Pour donner à votre puzzle une véritable allure de tableau.\nAssure une fixation et une protection durables.",
  "i18n.additionalProducts.roll.description": "Pour les puzzles de 48 à 2000 pièces",
  "i18n.additionalProducts.roll.hook": "Pas de table disponible ? Aucun problème !\nEnroulez votre puzzle, rangez-le et continuez plus tard.",
  "i18n.adventCalendarOverlay.activate": "Afficher l’aperçu des 24 petites fenêtres",
  "i18n.adventCalendarOverlay.deactivate": "Masquer l’aperçu des 24 petites fenêtres",
  "i18n.adventCalendarOverlay.notice": "(Les numéros et les lignes ne seront pas imprimés)",
  "i18n.button.addToCart": "Ajouter au panier",
  "i18n.button.apply": "Appliquer",
  "i18n.button.back": "Retour",
  "i18n.button.cancel": "Annuler",
  "i18n.button.cancelAndFix": "Modifier maintenant",
  "i18n.button.chooseSmartSorted": "Avec SMART SORTED",
  "i18n.button.close": "Fermer",
  "i18n.button.continue": "Continuer",
  "i18n.button.createNewTextPlaceholders": "Entrez votre texte",
  "i18n.button.ignore": "Ignorer",
  "i18n.button.ignoreAndContinue": "Continuer",
  "i18n.button.mobile.createNewTextPlaceholders": "Texte",
  "i18n.button.noChanges": "Sans SMART SORTED",
  "i18n.button.ok": "OK",
  "i18n.button.photos": "Photos",
  "i18n.button.retry": "Relancer",
  "i18n.button.uploadPhotos": "Téléchargement photo(s)",
  "i18n.button.withSmartSorted": "Avec SMART SORTED",
  "i18n.button.withoutSmartSorted": "Sans SMART SORTED",
  "i18n.control.colorChooser.color": "Couleur",
  "i18n.control.fontChooser.placeholderText": "Police de caractères",
  "i18n.control.imageQuality.checkImages": "Contrôle de la résolution de la photo",
  "i18n.control.imageQuality.imageSuitability": "Qualité de la photo:",
  "i18n.control.imageQuality.indicatorAltText": "Qualité de la photo",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.templateChooser.title": "Choix du modèle",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Pour une meilleure lisibilité, veuillez raccourcir le texte / ligne.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "La police de caractères choisie est trop large pour ce texte.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "La taille maximale possible de la police de caractères est atteinte pour ce texte.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "La taille minimale possible de la police de caractères est atteinte pour ce texte.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Veuillez insérer un retour à la ligne",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Veuillez continuer à écrire sur une deuxième ligne ou agrandissez le champ réservé au texte.",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Veuillez vérifier votre texte. Cette police ne prend pas en charge tous les caractères.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "Le nombre maximum de caractères a été atteint",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Pour plus de lisibilité, veuillez raccourcir le texte / ligne.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Veuillez agrandir le champ réservé au texte",
  "i18n.dialog.deletePlaceholder.message": "Cette étape ne peut être annulée",
  "i18n.dialog.deletePlaceholder.title": "Voulez-vous vraiment supprimer l’espace réservé?",
  "i18n.dialog.error.title": [
    "Une erreur s'est produite",
    "Quelques erreurs se sont produites"
  ],
  "i18n.dialog.insufficientImageQuality.message": "La résolution de cette image est trop faible afin d’imprimer le motif de manière optimale !",
  "i18n.dialog.smartSorted.message": "Avec SMART SORTED, vous montez votre puzzle de 1000 pièces de manière innovante et sans effort, même sans modèle.",
  "i18n.dialog.smartSorted.title": "Succès garanti avec ce puzzle",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Cliquez s’il vous plaît sur \"{{text}}\" pour modifier le titre de la boîte. ",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Le titre de la boîte n’a pas été modifié",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Continuer sans titre sur la boîte",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "Insérez s’il vous plaît une photo en cliquant sur l’espace réservé",
    "Insérez s’il vous plaît une photo en cliquant sur les espaces réservés"
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "Un espace réservé est vide",
    "Quelques espaces réservés sont vides"
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Un espace réservé au texte n’a pas été modifié.",
    "Quelques espaces réservés aux textes n’ont pas été modifiés."
  ],
  "i18n.dialog.unchangedPlaceholders.misc.message": [
    "Cliquez s’il vous plaît sur l’espace réservé au texte pour modifier votre texte",
    "Cliquez s’il vous plaît sur l’espace réservé au texte pour modifier votre texte"
  ],
  "i18n.dialog.unchangedPlaceholders.misc.title": [
    "Quelques espaces réservés n’ont pas été modifiés",
    "Quelques espaces réservés n’ont pas été modifiés"
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "Cliquez s’il vous plaît sur l’espace réservé au texte pour modifier votre texte",
    "Cliquez s’il vous plaît sur les espaces réservés aux textes pour modifier vos textes"
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "Un espace réservé au texte n’a pas été modifié",
    "Quelques espaces réservés aux textes n’ont pas été modifiés"
  ],
  "i18n.dialog.unchangedPlaceholders.title": "Champs réservés non modifiés",
  "i18n.error.additionalInfoItemsError.message": "Erreur de chargement de la couche d'informations",
  "i18n.error.additionalInfoItemsError.title": "Erreur de chargement",
  "i18n.error.deprecatedBrowserError.message": "Votre navigateur n’est plus à jour. Nous vous invitons à le mettre à jour vers une version plus récente.",
  "i18n.error.deprecatedBrowserError.title": " ",
  "i18n.error.designerExpiredError.message": "Vous avez interrompu la création depuis un certain temps. Elle ne peut être poursuivie. Veuillez recommencer le processus de création.",
  "i18n.error.designerExpiredError.title": "Création annulée",
  "i18n.error.fontLoadingError.message": "Une police n'a pas pu être chargée",
  "i18n.error.fontLoadingError.title": "Erreur de chargement",
  "i18n.error.imageLoadingError.message": "Une photo n'a pu être téléchargée. Elle a été retirée de la zone de conception et de la galerie.",
  "i18n.error.imageLoadingError.title": "Erreur de téléchargement",
  "i18n.error.imageProvisionError.message": "Une ou plusieurs photos ne peuvent être traitées. Le type de média n'est probablement pas accepté.",
  "i18n.error.imageProvisionError.title": "Une photo n'a pu être traitée.",
  "i18n.error.imageSelectionError.message": "Fichier \"{{reference1}}\" n'a pu être traité.",
  "i18n.error.imageSelectionError.title": "Erreur lors du téléchargement de la photo.",
  "i18n.error.imageSizeLimitExceededError.message": "L’image que vous venez de télécharger est trop grande.\nVeuillez réduire l’image à moins de 180 mégapixels et la télécharger à nouveau.",
  "i18n.error.imageSizeLimitExceededError.title": "Erreur lors du téléchargement de la photo.",
  "i18n.error.imageUploadError.message": "Un problème de connection s'est produit.Veuillez réessayer ultérieurement.",
  "i18n.error.imageUploadError.title": "Erreur lors du téléchargement photo.",
  "i18n.error.inlineSVGLoadingError.message": "Cadre de tolérance \"{{reference1}}\" n'a pu être téléchargé.",
  "i18n.error.inlineSVGLoadingError.title": "Erreur de téléchargement",
  "i18n.error.invalidCharConfigError.message": "La police de caratères ne peut être utilisée. Veuillez choisir une autre police.",
  "i18n.error.invalidCharConfigError.title": "Police non applicable",
  "i18n.error.malformedProductError.message": "Un ou plusieurs produits n’ont pas pu être transférés sur le serveur. Il est possible que le produit sélectionné ne soit plus disponible ou que la création du produit ait pris trop de temps. Nous en sommes désolés. Nous vous prions de bien vouloir recommencer votre création.",
  "i18n.error.malformedProductError.title": "Erreur de chargement",
  "i18n.error.notInStockError.message": "Le produit sélectionné n’est malheureusement plus disponible actuellement.\nEn cliquant sur notre logo en haut à gauche, vous aurez accès à la page d’accueil. Vous pourrez y choisir un autre produit.",
  "i18n.error.notInStockError.title": " ",
  "i18n.error.offlineNotice": "Votre connexion internet semble avoir été interrompue. Vous pourrez continuer à concevoir votre produit dès que la connection a été rétablie.",
  "i18n.error.templateLoadingError.message": "Modèle \"{{ error.reference[0] }}\" n'a pu être téléchargé.\nVeuillez réessayer ultérieurement.",
  "i18n.error.templateLoadingError.title": "Erreur de téléchargement",
  "i18n.error.transformationError.message": "La modification n’a pu être appliquée",
  "i18n.error.transformationError.title": "Erreur de modification",
  "i18n.error.traudlLoadingError.message": "Veuillez réessayer ou utiliser une autre image.",
  "i18n.error.traudlLoadingError.title": "Un filtre IA n’a pu être appliqué.",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" a un type de média non accepté.",
  "i18n.error.unsupportedMediaTypeError.title": "Erreur lors du téléchargement de la photo.",
  "i18n.error.uploadProductError.message": "Un ou plusieurs produits n'ont pu être transmis au serveur.\nVeuillez réessayer ultérieurement.",
  "i18n.error.uploadProductError.title": "Erreur de transfert",
  "i18n.error.zoomModeError.message": "Le texte de votre création précédente n’a pu être utilisé. Veuillez entrer un nouveau texte.",
  "i18n.error.zoomModeError.title": "Texte non adopté",
  "i18n.gallery.uploadPhotos.info": "Veuillez cliquer sur le bouton \"Télécharger photo\"",
  "i18n.gallery.uploadProgress": [
    "Téléchargement photo ...",
    "Photos téléchargées: {{current}} de {{total}}"
  ],
  "i18n.price.price": "Prix",
  "i18n.price.reduction": "Vous économisez ",
  "i18n.price.total": "Prix total",
  "i18n.priceDisplay.times": [
    "{{value}} exemplaire à {{pricePerUnit}}",
    "{{value}} exemplaires à {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Accessoires (en option)",
  "i18n.progressOverlay.message.lines.one": "Nous vous remercions pour votre création.",
  "i18n.progressOverlay.message.lines.two": "Votre commande est en cours de traitement...",
  "i18n.template.insertText": "Entrez votre texte ici",
  "i18n.toolbox.gallery.title": "Sélectionner photos",
  "i18n.toolbox.image.title": "Editer photo",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 photo",
    "{{value}} photos"
  ],
  "i18n.toolbox.layout.title": "Modifier modèle",
  "i18n.toolbox.layout.triggerText": "Modèle",
  "i18n.toolbox.preview.title": "Prévisualisation 3D ",
  "i18n.toolbox.productChooser.title": "Modifier produit",
  "i18n.toolbox.productChooser.triggerText": "Produit",
  "i18n.toolbox.text.title": "Traiter le texte"
};


export class LocaleFrCA {
  public getPlural(n: number): number
  {
    const pluralForm = (n > 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
